import { Action } from '@ngrx/store';

import { BookstoreAvailability } from './bookstore-availability';

export enum BookstoreAvailabilityActionTypes {
  BOOKSTORE_AVAILABILITIES_REQUESTED = '[Bookstore availability] Bookstore availabilities requested',
  BOOKSTORE_AVAILABILITY_REQUEST_UNLESS_CACHED = '[Bookstore availability] Bookstore availability request unless cached',
  BOOKSTORE_AVAILABILITY_REQUESTED = '[Bookstore availability] Bookstore availability requested',
  BOOKSTORE_AVAILABILITY_LOADED = '[Bookstore availability] Bookstore availability loaded',
  BOOKSTORE_AVAILABILITY_LOADING_FAILED = '[Bookstore availability] Bookstore availability loading failed',
}

export interface ResourceIdPayload {
  resourceId: string;
}

export class FetchBookstoreAvailabilitiesAction implements Action {
  readonly type =
    BookstoreAvailabilityActionTypes.BOOKSTORE_AVAILABILITIES_REQUESTED;

  constructor(public payload: ResourceIdPayload) {}
}

export interface BookstoreAndResourceIdPayload extends ResourceIdPayload {
  bookstoreId: string;
}

export class FetchBookstoreAvailabilityUnlessCachedAction implements Action {
  readonly type =
    BookstoreAvailabilityActionTypes.BOOKSTORE_AVAILABILITY_REQUEST_UNLESS_CACHED;

  constructor(public payload: BookstoreAndResourceIdPayload) {}
}

export class FetchBookstoreAvailabilityAction implements Action {
  readonly type =
    BookstoreAvailabilityActionTypes.BOOKSTORE_AVAILABILITY_REQUESTED;

  constructor(public payload: BookstoreAndResourceIdPayload) {}
}

export interface BookstoreAndAvailabilityPayload
  extends BookstoreAndResourceIdPayload {
  bookstoreAvailability: BookstoreAvailability;
}

export class BookstoreAvailabilityLoadedAction implements Action {
  readonly type =
    BookstoreAvailabilityActionTypes.BOOKSTORE_AVAILABILITY_LOADED;

  constructor(public payload: BookstoreAndAvailabilityPayload) {}
}

export interface BookstoreAvailabilityErrorAndIdPayload
  extends BookstoreAndResourceIdPayload {
  error: any;
}

export class BookstoreAvailabilityLoadingFailedAction implements Action {
  readonly type =
    BookstoreAvailabilityActionTypes.BOOKSTORE_AVAILABILITY_LOADING_FAILED;

  constructor(public payload: BookstoreAvailabilityErrorAndIdPayload) {}
}

export type BookstoreAvailabilityActions =
  | FetchBookstoreAvailabilitiesAction
  | FetchBookstoreAvailabilityUnlessCachedAction
  | FetchBookstoreAvailabilityAction
  | BookstoreAvailabilityLoadedAction
  | BookstoreAvailabilityLoadingFailedAction;
